import { isEmptyString } from '../util/string';

const sanitizeUri = uri => {
  if (uri) {
    return uri
      .toString()
      .replace("'", '-')
      .replace(/\s/gi, '-')
      .replace(/[^a-z0-9-]/gim, '');
  }

  return null;
};

/**
 * Build booking widget url with optional utm codes
 * @param {String} id id hash of location
 * @param {String} referrerLocationId id hash of referring CDP
 * @param {String} utmCodesFrom what url codes to append
 */
export const buildBookingWidgetUrl = ({ id }, utmCodesFrom, referrerLocationId) => {
  const utmCodes = {};
  const defaultUrl = `/book-online/${id}`;
  if (utmCodesFrom === 'SRP' || utmCodesFrom === 'CDP') {
    utmCodes.medium = 'inproduct';
  }

  if (utmCodesFrom === 'SRP') {
    utmCodes.source = 'search_best_match';
    utmCodes.campaign = 'srp_telemed_best_match';
  } else if (utmCodesFrom === 'CDP') {
    utmCodes.source = 'cdp_telemed_module';
    utmCodes.term = `solv-${referrerLocationId}`;
  }

  return `${defaultUrl}?${Object.keys(utmCodes)
    .map(c => `utm_${c}=${utmCodes[c]}`)
    .join('&')}`;
};

export const createLocationUrlFromLocation = location => {
  if (location) {
    const name = !isEmptyString(location.displayNamePrimary)
      ? location.displayNamePrimary.toLowerCase()
      : location.name.toLowerCase();
    const cityState = `${location.city.toLowerCase()}-${location.state.toLowerCase()}`;
    const id = location.id;
    return `/${[name, cityState, id].map(sanitizeUri).join('-')}`;
  }

  return null;
};
